import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { faqs } from "../../data/landing";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section tone="white" narrow cta="Yes, I'm ready to start" data-id="element-126" data-mp="uru8ng07bu39">
      <SectionHeading eyebrow="Questions" title="Frequently asked questions" data-id="element-127" data-mp="70yjkqn4rczp" />
      <div className="mt-10 space-y-3" data-id="element-128" data-mp="731jq3hzymi5">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <div key={f.q} className="overflow-hidden rounded-2xl border border-line bg-cream" data-id="element-129" data-mp="gzxihhi3fu9i" data-mpi={i}>
              <h3 data-id="element-130" data-mp="bzrymni2fc1z">
                <button type="button" aria-expanded={isOpen} aria-controls={`faq-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 p-5 text-left text-[16px] font-bold text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-rose md:text-[17px]" data-id="element-131" data-mp="bz9s8y1ovhgc">
                  {f.q}
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-rose transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-132" data-mp="rs6kfnx8onbw" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-133" data-mp="41j9ets11hl4">
                {isOpen && <motion.div id={`faq-${i}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: "auto",
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-134" data-mp="8465j6vqdoo4">
                    <p className="px-5 pb-5 text-[16px] leading-relaxed text-inkSoft" data-id="element-135" data-mp="3gio8wvaq8g1e">{f.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </Section>;
}